import useMutation from 'hooks/use-mutation';
import { deleteSurfaceNodeMutation } from 'graphql/surface-node/mutations/delete-surface-node';
import useRemoveNodeFromCache from 'components/canvas/hooks/use-remove-node-from-cache';
import useFetchNodeFromCacheById from 'components/canvas/hooks/use-fetch-node-from-cache-by-id';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';

export function useDeleteSurfaceNodeMutation(surfaceId: string) {
  const removeNodeFromCache = useRemoveNodeFromCache();
  const saveNodeInCache = useSaveNodeInCache();
  const fetchNodeFromCacheById = useFetchNodeFromCacheById(surfaceId);
  const [deleteSurfaceNode] = useMutation(deleteSurfaceNodeMutation);

  return (...params) => {
    const [options] = params;

    const node = fetchNodeFromCacheById(options.variables.id);

    node && removeNodeFromCache(node);

    return deleteSurfaceNode(...params).then((response) => {
      if (response.isFailure) {
        saveNodeInCache(node);
      }

      return response;
    });
  };
}

export default useDeleteSurfaceNodeMutation;
